<template>
  <div>
    <b-toaster name="b-toaster-top-full"></b-toaster>
    <b-toast
      v-for="announcement in announcementsToShow"
      :key="announcement.id"
      toaster="b-toaster-top-full"
      variant="warning"
      solid
      no-auto-hide
      visible
      @hidden="setAnnouncementSeen(announcement.id)">
      <div
      v-dompurify-html="announcement.content"
      class="text-center w-75 mx-auto"></div>
    </b-toast>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return { };
  },
  computed: {
    ...mapState('announcement', {
      currentAnnouncements: state => state.currentAnnouncements,
      announcementsSeen: state => state.announcementsSeen
    }),
    announcementsToShow() {
      return this.currentAnnouncements.filter(announcement => !this.announcementsSeen.includes(announcement.id));
    }
  },
  methods: {
    setAnnouncementSeen(announcementId) {
      this.$store.dispatch('announcement/addAnnouncementSeen', announcementId);
    }
  }

};

</script>

<style scoped lang="scss">
::v-deep .b-toaster-top-full {
  width: 70% !important;
  left: 15% !important;
}
</style>
